import { functions } from "../firebase";
import { SubscriptionLandingInfo } from "../../types/Paywall";

// The callable returns the richer landing shape ThePath persists at
// Community/{id}/landingPage/info, which adds a personalized "how it works"
// section on top of the paywall landing fields.
export type LandingHowStep = { title: string; body: string };
export type GeneratedLandingInfo = SubscriptionLandingInfo & {
  howTitle?: string;
  howSteps?: LandingHowStep[];
};

type GenerateParams = {
  communityId: string;
  locale?: string;
};

// Regenerates a community's public landing copy server-side and persists it to
// Community/{id}/landingPage/info. Unlike the roundtable agenda, there is no
// client fallback: this is an explicit admin action, so failures surface to the
// caller to show in the UI.
export const generateLandingInfo = async ({
  communityId,
  locale,
}: GenerateParams): Promise<GeneratedLandingInfo> => {
  const callable = functions.httpsCallable("generateLandingInfo");
  const result = await callable({ communityId, locale });
  const landingInfo = (result?.data as { landingInfo?: GeneratedLandingInfo })
    ?.landingInfo;

  if (!landingInfo) {
    throw new Error("Landing generation returned no content");
  }
  return landingInfo;
};
